import * as React from "react";
import { Skeleton, VStack } from "@chakra-ui/react";

const TextFieldSkeleton: React.FC = () => (
  <VStack align="start" spacing="4px">
    <Skeleton height="16px" width="100px" borderRadius="4px" />
    <Skeleton height="16px" width="100px" borderRadius="4px" />
  </VStack>
);

export default TextFieldSkeleton;
